import { useQuery } from '@apollo/react-hooks';
import { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import GetSegmentBreakdown from '../../../gql/get-segment-breakdown';

const useSegmentBreakdown = (accountId) => {
  const theme = useContext(ThemeContext);

  const { data, loading, error } = useQuery(GetSegmentBreakdown, {
    variables: {
      input: {
        account_id: accountId ? parseInt(accountId, 10) : 0,
      },
    },
    skip: !accountId || isNaN(parseInt(accountId)),
    fetchPolicy: 'cache-and-network',
  });

  // Transform API data into component format
  if (loading) {
    return {
      loading: true,
      error: null,
      segments: null,
    };
  }

  if (error) {
    return {
      loading: false,
      error,
      segments: null,
    };
  }

  const breakdown = data?.getSegmentBreakdown;

  if (!breakdown) {
    return {
      loading: false,
      error: null,
      segments: null,
    };
  }

  const segments = [
    {
      label: 'Super Fan',
      description: '10+ events, 75%+ attendance',
      count: breakdown.super_fan || 0,
      color: theme?.colors?.segments?.superFan || '#22C55E',
      background: theme?.colors?.segments?.superFan
        ? `${theme.colors.segments.superFan}1A`
        : 'rgba(34, 197, 94, 0.1)',
    },
    {
      label: 'Regular Fan',
      description: '5+ events, 50%+ attendance',
      count: breakdown.regular_fan || 0,
      color: '#3B82F6',
      background: 'rgba(59, 130, 246, 0.1)',
    },
    {
      label: 'Casual Fan',
      description: '2-4 events',
      count: breakdown.casual_fan || 0,
      color: '#06B6D4',
      background: 'rgba(6, 182, 212, 0.1)',
    },
    {
      label: 'Occasional',
      description: 'Infrequent visitors, still active',
      count: breakdown.occasional || 0,
      color: '#A78BFA',
      background: 'rgba(167, 139, 250, 0.1)',
    },
    {
      label: 'First-Timer',
      description: '1 event',
      count: breakdown.first_timer || 0,
      color: '#F59E0B',
      background: 'rgba(245, 158, 11, 0.1)',
    },
    {
      label: 'Inactive',
      description: 'No events or 14+ months inactive',
      count: breakdown.inactive || 0,
      color: '#DC2626',
      background: 'rgba(220, 38, 38, 0.1)',
    },
  ];

  return {
    loading: false,
    error: null,
    segments,
  };
};

export default useSegmentBreakdown;
